export enum ContractModel {
    INSURANCE = 'INSURANCE',
    MAINTENANCE = 'MAINTENANCE',
    USE = 'USE'
}
